module.exports = __webpack_public_path__ + "img/pageinx.34ad1e76.png";